import type { TeamsState } from "./types";

export const INITIAL_TEAMS_STATE: TeamsState = {
    isEnabled: true,
    selectedTeamId: null,
};
